'use strict';
var React = require('react');
var AccountSignUpModal = require('./account_signup_modal').default;
var ContactUsModal = require('./contact_form_modal').default;
module.exports = function () {
    function repeatFeature1(feature, featureIndex) {
        return React.createElement('li', { 'className': 'package-card-feature-item' }, React.createElement('div', {
            'className': 'package-card-feature-text',
            'dangerouslySetInnerHTML': { __html: feature }
        }));
    }
    function onClick2() {
        this.props.toggleAccountSignupModal('Standard');
    }
    function onClick3() {
        this.props.toggleAccountSignupModal(this.props.plan.name);
    }
    function onClick4() {
        this.props.toggleAccountSignupModal(this.props.plan.name);
    }
    function onClick5() {
        this.props.toggleContactUs('enterprise');
    }
    function onSubmit6(event, accountDetails) {
        this.onSubmit(event, accountDetails, this.props.selectedPlans);
    }
    return React.createElement('div', {
        'className': 'package-card-wrapper',
        'id': this.props.plan.name
    }, React.createElement('div', { 'className': 'package-card' }, React.createElement('div', { 'className': 'package-card-header' }, React.createElement('span', {}, this.props.plan.name)), this.hasFieldInMetadata('title') ? React.createElement('div', {
        'className': 'package-card-price-text',
        'key': '344'
    }, this.props.plan.metadata.title, ' ', this.hasFieldInMetadata('title-support-text') ? React.createElement('span', {
        'className': 'package-card-title-support-text',
        'key': '455'
    }, '/ ', this.props.plan.metadata['title-support-text']) : null) : null, React.createElement('div', { 'className': 'plan-card-description' }, this.hasFieldInMetadata('description') ? React.createElement('p', {
        'className': 'plan-description',
        'key': '673'
    }, this.props.plan.metadata.description) : null, this.hasFieldInMetadata('caption-text') ? React.createElement('span', {
        'className': 'plan-caption-text',
        'key': '801'
    }, this.props.plan.metadata['caption-text']) : null), React.createElement('div', { 'className': 'features' }, React.createElement.apply(this, [
        'ul',
        {},
        _.map(this.getFeatures(), repeatFeature1.bind(this))
    ])), React.createElement('div', { 'className': 'button-adds-container' }, this.props.plan.price === 0 && this.props.plan.name !== 'Enterprise' ? React.createElement('button', {
        'className': 'get-package-button',
        'type': 'button',
        'onClick': onClick2.bind(this),
        'key': '1292'
    }, 'get started') : null, this.props.plan.price !== 0 && !metypeFeatureToggles['free_trial'] ? React.createElement('button', {
        'className': 'get-package-button',
        'type': 'button',
        'onClick': onClick3.bind(this),
        'key': '1514'
    }, 'Buy Now') : null, this.props.plan.price !== 0 && metypeFeatureToggles['free_trial'] ? React.createElement('button', {
        'className': 'get-package-button',
        'type': 'button',
        'onClick': onClick4.bind(this),
        'key': '1740'
    }, 'Start Trial') : null, this.props.plan.name === 'Enterprise' ? React.createElement('button', {
        'className': 'get-package-button',
        'type': 'button',
        'onClick': onClick5.bind(this),
        'key': '1971'
    }, 'contact us') : null)), this.props.accountSignupModal && this.props.selectedPlans.name && this.props.selectedPlans.name !== 'Standard' ? React.createElement(AccountSignUpModal, {
        'closeAccountSignUpModal': this.props.closeAccountSignUpModal,
        'toggleAccountSignupModal': this.toggleAccountSignupModal,
        'onSubmit': onSubmit6.bind(this),
        'accountSignupModal': this.state.accountSignupModal,
        'planAccountSignup': true,
        'selectedPlans': this.props.selectedPlans,
        'disableGetStartedButton': this.state.disableGetStartedButton,
        'key': '2173'
    }) : null);
};


//////////////////
// WEBPACK FOOTER
// ./app/javascript/pages/metype_home/plan.rt
// module id = 893
// module chunks = 7